/* eslint-disable camelcase */
import { fetchEmbedData } from './../../wix-ricos-common';
import type { RichContentEditorProps } from './../../ricos-common';
import { LINK_PREVIEW_TYPE } from './../../ricos-content';

export default function linkPreviewStrategy(instance: string | undefined): RichContentEditorProps {
  if (!instance) {
    return {
      config: {},
    };
  }

  return {
    config: {
      [LINK_PREVIEW_TYPE]: {
        fetchData: fetchEmbedData(instance),
      },
    },
  };
}
